import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import { Link } from 'preact-router/match';

class SideBar extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return (
      <aside>
        <div className='container'>

          <button onClick={e => this.props.toggleAppMenu(e)} />
          <h4>{this.props.bookTitle}</h4>

          <nav>
            <Link href='/'
              activeClassName="active"
              onClick={e => this.props.toggleAppMenu(e)}>Start again</Link>
            <Link href='/book'
              activeClassName="active"
              onClick={e => this.props.toggleAppMenu(e)}>Read book</Link>
            <Link href='/about-book'
              activeClassName="active"
              onClick={e => this.props.toggleAppMenu(e)}>About the book</Link>
            <Link href='/about-author'
              activeClassName="active"
              onClick={e => this.props.toggleAppMenu(e)}>About the author</Link>
            <Link href='/about-eap'
              activeClassName="active"
              onClick={e => this.props.toggleAppMenu(e)}>About Editions At Play</Link>
            <Link href='/credits'
              activeClassName="active"
              onClick={e => this.props.toggleAppMenu(e)}>Book Credits</Link>
          </nav>
        </div>
        <div className='bg-overlay'
          onClick={e => this.props.toggleAppMenu(e)} />
      </aside>
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(SideBar, styles);



// WEBPACK FOOTER //
// ./app/frontend/components/partials/side-bar.jsx